import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","info","success"] */ "/opt/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/brands.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/home/products-list.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/buttons/add-to-cart.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/banner-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/banner-with-text-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/category-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/collection-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/fee-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/cards/wishlist-card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/next-image/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/categories-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/deals-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/grid-products-slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/hero-slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/ui/sliders/products-slider.js");
;
import(/* webpackMode: "eager" */ "/opt/app/src/components/ui/sliders/testimonials-slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/address/card-footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/src/components/user/orders/order-card.js");
